interface AvatarProps {
  src?: string | null;
  alt?: string;
  className?: string;
  imgClassName?: string;
  iconClassName?: string;
}

const joinClass = (...values: Array<string | undefined>) => values.filter(Boolean).join(' ');

const Avatar = ({ src, alt = 'avatar', className, imgClassName, iconClassName }: AvatarProps) => {
  const normalizedSrc = typeof src === 'string' ? src.trim() : '';

  return (
    <div
      className={joinClass(
        'overflow-hidden bg-slate-100 flex items-center justify-center text-slate-500',
        className
      )}
    >
      {normalizedSrc ? (
        <img src={normalizedSrc} alt={alt} className={joinClass('w-full h-full object-cover object-top', imgClassName)} />
      ) : (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          className={joinClass('w-[62%] h-[62%]', iconClassName)}
        >
          <circle cx="12" cy="8" r="3.5" />
          <path d="M4.8 19.2c1.6-3 4-4.5 7.2-4.5s5.6 1.5 7.2 4.5" strokeLinecap="round" />
        </svg>
      )}
    </div>
  );
};

export default Avatar;
